var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVivilazonaLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 760 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 8) scale(0.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 96 88 L 42 88 C 24 88 15 74 19 56 C 24 30 47 17 69 23 C 88 28 98 45 98 65 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 88 L 158 88 C 176 88 185 74 181 56 C 176 30 153 17 131 23 C 112 28 102 45 102 65 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 96 L 39 96 C 24 96 18 108 24 122 C 35 146 54 162 77 174 L 95 130 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 96 L 161 96 C 176 96 182 108 176 122 C 165 146 146 162 123 174 L 105 130 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 137 L 119 179 C 112 185 106 190 100 194 C 94 190 88 185 81 179 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59 60) scale(0.72)",
    fill: "none",
    stroke: "#0D1B3D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -14,
    width: 36,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -20v10M10 -20v10M-18 -5h36"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -9,
    cy: 4,
    r: 1.8,
    fill: "#0D1B3D",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 4,
    r: 1.8,
    fill: "#0D1B3D",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 4,
    r: 1.8,
    fill: "#0D1B3D",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142 61) scale(0.68)",
    fill: "#0D1B3D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -8,
    cy: -10,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: -9,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23 14c1-14 8-21 16-21S8 0 9 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14c1-12 7-18 14-18s13 6 14 18z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58 119) scale(0.67)",
    fill: "none",
    stroke: "#0D1B3D",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19 -7h38l-4-13h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17 -7v24h34V-7M-4 17V3h11v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19 -7c1 7 9 7 10 0 1 7 9 7 10 0 1 7 9 7 10 0 1 7 8 7 9 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142 119) scale(0.68)",
    fill: "#0D1B3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-22c-12 0-21 9-21 21 0 16 21 36 21 36S21 15 21-1C21-13 12-22 0-22zm0 29a9 9 0 1 1 0-18 9 9 0 0 1 0 18z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 165) scale(0.58)",
    fill: "#0D1B3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-24h10l3 8 8-3 7 7-3 8 8 3v10l-8 3 3 8-7 7-8-3-3 8h-10l-3-8-8 3-7-7 3-8-8-3V-1l8-3-3-8 7-7 8 3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 4,
    r: 9,
    fill: "#2563EB"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 101,
    r: 24,
    fill: "#0D1B3D"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 118,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 82,
    fontWeight: 700,
    letterSpacing: -2,
    fill: "white"
  }, "ViviLaZona")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivilazonaLogoWhite);
export default __webpack_public_path__ + "static/media/vivilazona-logo-white.7c21b561bbdf7f01fa3861fd53677e81.svg";
export { ForwardRef as ReactComponent };